export function rearrangeNameBySurname(name: string) {
  const nameParts = name.split(' ')

  if (nameParts.length > 1) {
    // Extract the first part of the name
    const firstName = nameParts.shift()

    if (firstName?.toLowerCase() === 'sir') {
      // if sir is the first name, can ignore it and use the rest of the nameParts
      // e.g Sir Peter Blake, will result in Blake, Peter
      return nameParts.reverse().join(', ')
    }

    // Specific solution for names that just have initials
    // for example L S Lowry, will become Lowry, L S
    if (nameParts.length >= 2) {
      if (firstName?.length === 1 && nameParts[0].length === 1) {
        const second = nameParts[0]
        nameParts.splice(0, 1)

        return `${nameParts.join(' ')}, ${firstName} ${second}`
      }
    }

    return `${nameParts.join(' ')}, ${firstName}`
  }

  // Return the name as is if it doesn't contain spaces
  return name
}
